import PropTypes from 'prop-types';

import * as Colors from 'consts/colors.json';

const ProgressBar = ({
  backgroundColor,
  percentage,
  transitionDuration,
  transitionTimingFunction,
}) => (
  <div className="rounded h-2 overflow-hidden bg-gray-2">
    <div
      className={`rounded h-2 overflow-hidden w-full ${
        percentage >= 100 ? 'bg-green-3' : 'rounded-t rounded-l bg-blue-3'
      } motion-reduce:duration-almost-0`}
      style={{
        backgroundColor,
        transitionDuration,
        transitionTimingFunction,
        transform: `translateX(-${100 - percentage}%)`,
      }}
    />
  </div>
);

const acceptedColors = [
  Colors.GRAY_3.hex,
  Colors.GRAY_4.hex,
  Colors.GRAY_5.hex,
  Colors.GRAY_6.hex,
  Colors.GRAY_7.hex,
  Colors.YELLOW_3.hex,
  Colors.CYAN_3.hex,
  Colors.RED_3.hex,
  Colors.RED_4.hex,
  Colors.BLUE_2.hex,
  Colors.BLUE_3.hex,
  Colors.ORANGE_3.hex,
  Colors.ORANGE_4.hex,
  Colors.GREEN_2.hex,
  Colors.GREEN_3.hex,
  Colors.GREEN_5.hex,
];

// TODO: until transition duration is exposed as css class instead of inline style it will override the 'prefers reduce motion' rule

ProgressBar.defaultProps = {
  backgroundColor: null,
  transitionDuration: '0.3s',
  transitionTimingFunction: 'linear',
};

ProgressBar.propTypes = {
  /**
   * Override for background color.
   */
  backgroundColor: PropTypes.oneOf(acceptedColors),
  /**
   * Percent complete.
   */
  percentage: PropTypes.number.isRequired,
  /**
   * Transition Duration.
   */
  transitionDuration: PropTypes.string,
  /**
   * Transition Timing.
   */
  transitionTimingFunction: PropTypes.string,
};

export default ProgressBar;
